import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/root.types';
import { RegistrationResponse } from 'sync/authentication-service';

export const registrationSliceName = 'registration';

const getInitialState = () => ({ registration: null as RegistrationResponse | null });

export const registrationSlice = createSlice({
  name: registrationSliceName,
  initialState: getInitialState(),
  reducers: {
    setRegistration(state, { payload }: PayloadAction<RegistrationResponse | null>) {
      state.registration = payload;
    },
    updateRegistration(state, { payload }: PayloadAction<Partial<RegistrationResponse>>) {
      state.registration = { ...((state.registration || {}) as RegistrationResponse), ...payload };
    },
    reset(state) {
      Object.assign(state, getInitialState());
    },
  },
});

export const { setRegistration, updateRegistration, reset } = registrationSlice.actions;

export const selectRegistration = (state: RootState): RegistrationResponse | null => {
  return state[registrationSliceName].registration;
};
